import { useEffect, useState } from "react";

import { AddMoreButton, SectionTitle } from "@components";
import { Child } from "./Child";
import { NewChild } from "./NewChild";

import { ChildType } from "@type/HRM/family";
import Accordion from "@components/Accordion";
import { Text } from "@pentabd/ui";

interface ChildrenPropsType {
  childrenInfo: ChildType[];
  changeChildrenInfo: (data: ChildType) => void;
  removeChildInfo: (childID: number) => void;
  getFamilyInfoRequestOngoing: boolean;
  updateChildRequestOngoing: boolean;
  deleteChildRequestOngoing: boolean;
  isProfileDisabled: boolean;
  canCreateEmployee: boolean;
  canEditEmployee: boolean;
}

const Children = ({
  childrenInfo,
  changeChildrenInfo,
  removeChildInfo,
  getFamilyInfoRequestOngoing,
  updateChildRequestOngoing,
  deleteChildRequestOngoing,
  isProfileDisabled,
  canCreateEmployee,
  canEditEmployee,
}: ChildrenPropsType) => {
  const [newChildFormShow, setNewChildFormShow] = useState(false);
  const [disabledProfile, setDisabledProfile] = useState<boolean>(false);
  const handleNewChildFormShow = (isShow: boolean) =>
    setNewChildFormShow(isShow);

  useEffect(() => {
    //for create
    if (
      (childrenInfo?.length === 0 || childrenInfo === null) &&
      canCreateEmployee
    ) {
      setDisabledProfile(true);
    }
    //for edit
    if (childrenInfo?.length > 0 && childrenInfo !== null && canEditEmployee) {
      setDisabledProfile(true);
    }
  }, [childrenInfo, canCreateEmployee, canEditEmployee]);

  return (
    <div className="d-flex flex-column gap-8 pb-10">
      <SectionTitle
        label="EMPLOYEE.FAMILY_INFO.FORM.CHILDREN_INFO.HEADING"
        size="lg"
        noBorder
      />

      {childrenInfo?.map((child) => {
        return (
          <Accordion
            key={child.id}
            accordionBody={
              <Child
                childInfo={child}
                changeChildrenInfo={changeChildrenInfo}
                removeChildInfo={removeChildInfo}
                updateChildRequestOngoing={updateChildRequestOngoing}
                getFamilyInfoRequestOngoing={getFamilyInfoRequestOngoing}
                deleteChildRequestOngoing={deleteChildRequestOngoing}
                isProfileDisabled={isProfileDisabled || !disabledProfile}
              />
            }
            className="pointer p-8 bg-primary-25 rounded-4 border border-primary"
            accordionHeader={
              <Text size="lg" weight="semibold" color="dark">
                {child.nameEn}
              </Text>
            }
          />
        );
      })}

      {newChildFormShow ? (
        <NewChild
          handleNewChildFormShow={handleNewChildFormShow}
          changeChildrenInfo={changeChildrenInfo}
          updateChildRequestOngoing={updateChildRequestOngoing}
          isProfileDisabled={isProfileDisabled || !disabledProfile}
        />
      ) : (
        <AddMoreButton
          label="EMPLOYEE.FAMILY_INFO.FORM.CHILDREN_INFO.ADD_MORE_BUTTON"
          clickAction={() => handleNewChildFormShow(true)}
          disabled={isProfileDisabled || !disabledProfile}
        />
      )}
    </div>
  );
};

export default Children;
